import { render } from "./ProjectSettingsAccointAddSocial.vue?vue&type=template&id=6028cf08"
import script from "./ProjectSettingsAccointAddSocial.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsAccointAddSocial.vue?vue&type=script&lang=js"

import "./ProjectSettingsAccointAddSocial.vue?vue&type=style&index=0&id=6028cf08&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__